import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetFeedRequest } from './get-feed-request';
import type { IGetFeedResponse } from './get-feed-response';
import { getFeedResponseSchema } from './get-feed-response';

export async function getFeedApi(
  params?: IGetFeedRequest,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetFeedResponse>> {
  return getRequest<IGetFeedResponse>({
    path: '/feed',
    schema: getFeedResponseSchema,
    options: {
      ...options,
      params: params?.cursor ? { cursor: params.cursor } : undefined,
    },
  });
}
